import React, { useEffect, useState } from 'react'
import styles from './style.module.scss'
import { FormWrapper } from '@Root/HOCs'
import { Field } from '@Root/components'
import { fieldTooltipManagerSelectors } from '@Root/store'
import { useError, useToggle } from '@Root/hooks'
import { useSelector } from 'react-redux'

const titles = { onRead: 'Student Financial Support', onEdit: 'Edit Student Financial Support', onCreate: 'Create Student Financial Support' }
export const StudentFinancialSupportForm = ({
  canEdit,
  canDelete,
  onDelete,
  onSave,
  onCancel,
  isNew,
  initialValue,
  isLoading,
  isSuccess,
  options,
  onOpenDescriptionModal,
}) => {
  const [data, setData] = useState({})
  const { errors, setError } = useError()
  const [isEditable, toggleEditable] = useToggle(Boolean(isNew))
  const descriptions = useSelector(fieldTooltipManagerSelectors.contactDescriptions).person.hesa_details.student_course_sessions

  useEffect(() => {
    if (initialValue) setData(initialValue)
  }, [initialValue])

  useEffect(() => {
    if (isSuccess) toggleEditable()
  }, [isSuccess])

  const onChangeValue = field => value => {
    setData(prevState => ({ ...prevState, [field]: value }))
  }

  const onCancelEditMode = () => {
    onChangeMode()
    setData(initialValue)
  }

  const validateForm = () => {
    const { financial_support_type_id } = data
    if (!financial_support_type_id) {
      setError('financial_support_type_id', 'Required')
      return false
    }

    return true
  }

  const onChangeMode = () => {
    toggleEditable()
  }

  const onSubmitForm = () => {
    if (!validateForm()) return
    onSave(data)
  }

  const onCancelEdit = () => {
    if (!isNew) {
      onCancelEditMode()
      return
    }
    onCancel()
  }

  const { onEdit, onRead, onCreate } = titles
  return (
    <div className={styles.form}>
      <FormWrapper
        buttons={isEditable ? ['cancel', ...(canDelete ? ['delete'] : []), 'save'] : []}
        buttonsNames={[{ button: 'delete', name: 'Delete this Student Financial Support' }]}
        buttonsAreDisabled={isLoading}
        isSpinning={isLoading}
        clickCancelButtonHandler={onCancelEdit}
        clickDeleteButtonHandler={onDelete}
        clickSaveButtonHandler={onSubmitForm}
        editTitle={onEdit}
        readTitle={onRead}
        createTitle={onCreate}
        clickToggleEditModeButtonHandler={onChangeMode}
        isEditable={isEditable}
        canEdit={canEdit}
        isCreate={isNew}
        idForm={data?.id ? `student_financial_support_${data?.id}` : null}
        isSuccess={isSuccess}
      >
        <div className={styles.grid}>
          <div className={styles.column}>
            <div className={styles.row}>
              <Field
                label={'Financial support type'}
                classNames={!isEditable ? ['borderless'] : []}
                style={{ width: 260 }}
                value={data.financial_support_type_id}
                onChange={onChangeValue('financial_support_type_id')}
                placeholder='Financial support type'
                isDisabled={!isEditable}
                isRequired={isEditable}
                options={options.financial_support_types}
                description={descriptions?.financial_support_type_id}
                onOpenDescriptionModal={onOpenDescriptionModal}
                field={'select'}
                error={errors.financial_support_type_id}
              />
              <Field
                label={'Access and participation flag'}
                classNames={!isEditable ? ['borderless'] : []}
                style={{ width: 260 }}
                value={data.access_participation_flag_id}
                onChange={onChangeValue('access_participation_flag_id')}
                placeholder='Access and participation flag'
                isDisabled={!isEditable}
                options={options.access_participation_flags}
                description={descriptions?.access_participation_flag_id}
                onOpenDescriptionModal={onOpenDescriptionModal}
                field={'select'}
              />
              <Field
                label={'Financial support amount'}
                classNames={!isEditable ? ['borderless'] : []}
                style={{ width: 260 }}
                value={data.financial_support_amount}
                onChange={onChangeValue('financial_support_amount')}
                placeholder='Financial support amount'
                isDisabled={!isEditable}
                description={descriptions?.financial_support_amount}
                onOpenDescriptionModal={onOpenDescriptionModal}
                field={'textField'}
                maxLength={6}
                restriction='digits'
              />
            </div>
          </div>
        </div>
      </FormWrapper>
    </div>
  )
}
